import TopMost from './TopMost';
import Basic from './Basic';
import Image from './Image';
import Article from './Article';
import Video from './Video';
import Locale from './Locale';
import AVUnit from './AVUnit';
import ArticleUnit from './ArticleUnit';
import NoIndex from './NoIndex';

const Helmets = {
  TopMost,
  Basic,
  Image,
  Article,
  Video,
  Locale,
  AVUnit,
  ArticleUnit,
  NoIndex,
};

export default Helmets;
